import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { ActivityTimelineViewV1Schema } from "./activity-timeline.js";
import { ClientResponsibilityTrailV1Schema } from "./client-responsibility-trail.js";
import { GovernanceCoverageV1Schema } from "./governance-coverage.js";
import { ManagerExceptionViewV1Schema } from "./manager-exception.js";
import { ReleaseLabelReasonV1Schema, ReleaseLabelV1Schema } from "./release-label.js";
export const InternalGovernanceViewV1Schema = z
    .object({
    schemaVersion: z.literal("internal-governance-view.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    generatedAt: z.string().datetime(),
    timeline: ActivityTimelineViewV1Schema,
    coverage: GovernanceCoverageV1Schema,
    releaseLabel: ReleaseLabelV1Schema,
    releaseLabelReasons: z.array(ReleaseLabelReasonV1Schema),
    managerExceptions: z.array(ManagerExceptionViewV1Schema),
    clientResponsibilityTrail: ClientResponsibilityTrailV1Schema,
    qaStatusSummary: z.string().min(1).optional(),
    reportHeadline: z.string().min(1).optional(),
    dkStatusSummary: z.string().min(1).optional(),
    passingVsApprovedSummary: z.string().min(1).optional(),
})
    .strict();
export const ClientSafeGovernanceTimelineBulletV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-governance-timeline-bullet.v1.0"),
    headline: z.string().min(1),
    summary: z.string().min(1),
})
    .strict();
export const ClientSafeGovernanceViewV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-governance-view.v1.0"),
    headline: z.string().min(1),
    subcopy: z.string().min(1),
    releaseLabelClientSafe: z.string().min(1),
    coverageSummary: z.string().min(1),
    timelineBullets: z.array(ClientSafeGovernanceTimelineBulletV1Schema).max(12),
    responsibilityBullets: z.array(z.string().min(1)).max(8),
    disclaimers: z.array(z.string().min(1)),
    managerExceptionSummary: z.string().min(1).optional(),
})
    .strict();
//# sourceMappingURL=governance-views.js.map